module.exports = __webpack_public_path__ + "static/media/carnival-video.55c3a388.jpg";